import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import Header from "../../Header/Header";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import { Row, Col, Button, Nav, Tab, Pagination } from "react-bootstrap";
import { Context } from "../../../utils/context";
import "react-datepicker/dist/react-datepicker.css";
import PendingOrdersTable from "./PendingOrdersTable/PendingOrdersTable";
import OrderConfirmed from "./OrderConfirmed/OrderConfirmed";
import PickupMaterial from "./PickupMaterial/PickupMaterial";
import Prossesing from "./Prossesing/Prossesing";
import Cancelled from "./Cancelled/Cancelled";
import RestichingOrders from "./RestichingOrders/RestichingOrders";
import Delivered from "./Delivered/Delivered";
import ReadyToDelivered from "./ReadyToDelivered/ReadyToDelivered";
import {
  OrderStatusIds,
  ReplaceStatusIds,
  ReturnStatusIds,
} from "../../../utils/common";

library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const { getData, Select2Data } = useContext(Context);

  const OrderByOptions = [
    { value: "ASC", label: "Sort-by date (Ascending)" },
    { value: "DESC", label: "Sort-by date (Descending)" },
  ];

  const resultsPerPageOptions = [
    { value: 25, label: "Results per page: 25" },
    { value: 50, label: "Results per page: 50" },
    { value: 100, label: "Results per page: 100" },
  ];

  const [statusCount, setStatusCount] = useState({});
  const [storeCategories, setStoreCategories] = useState([]);
  const [productCategories, setDesignCategories] = useState([]);
  const [vendorServices, setVendorServices] = useState([]);

  const GetAllCounts = async () => {
    const response = await getData("/common/masters/all-count-order-status");
    setStatusCount(response?.data);
  };

  // const getAllSCategories = async () => {
  //   const response = await getData("/common/masters/all-s-category");
  //   if (response?.success) {
  //     setStoreCategories(
  //       await Select2Data(response?.data?.allCategories, "s_category_id"),
  //     );
  //   }
  // };

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
    if (response?.data?.Store_Detail) {
      const productCategory = await getData(
        `/common/masters/all-store-product-categories/${response?.data?.Store_Detail?.id}`,
      );
      if (productCategory?.success) {
        setDesignCategories(
          await Select2Data(productCategory?.data, "category_id"),
        );
      }
      const vendorServices = await getData(
        `/common/masters/all-vendors-services/${response?.data?.Store_Detail?.id}`,
      );
      if (vendorServices?.success) {
        setVendorServices(
          await Select2Data(vendorServices?.data, "service_id"),
        );
      }
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  useEffect(() => {
    GetAllCounts();
    // getAllSCategories();
  }, []);

  const [payment_status, setPayment_status] = useState(null);
  const [return_status_id, setReturnStatus] = useState(1);
  const [searchOrderStatus, setSearchOrderSatatus] = useState(
    OrderStatusIds.PickupSchedued,
  );
  const [replace_order_status_id, setReplaceStatusId] = useState("");

  const [activeTab, setActiveTab] = useState("RefundRequest");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Orders"} link={"/employee/employee_details"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12 p-0 ">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  <div className="order-tab-holder">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="Pending"
                    >
                      <Row>
                        <Col sm={12}>
                          <Nav
                            variant="pills"
                            className="mb-3"
                            onSelect={(k) => setActiveTab(k)}
                          >
                            <Nav.Item>
                              <Nav.Link eventKey="Pending">
                                <span>{statusCount?.Pending}</span> {"    "}{" "}
                                Pending Order
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="OrderConfirmed">
                                <span>{statusCount?.OrderConfirmed}</span>{" "}
                                {"    "}
                                Order Confirm
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="PickupMaterial">
                                <span>{statusCount?.PickupMaterial}</span>{" "}
                                {"    "}
                                Pickup Material
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Prossesing">
                                <span>{statusCount?.Prossesing}</span>
                                {"    "}
                                Prossesing
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="ReadyToDelivered">
                                <span>{statusCount?.ReadyToDelivered}</span>
                                {"    "}
                                Ready To Delivered
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="Delivered">
                                <span>{statusCount?.Delivered}</span> {"    "}
                                Delivered
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link eventKey="RestichingOrders">
                                <span>{statusCount?.RestichingOrders}</span>
                                {"   "}
                                Restiching Orders
                              </Nav.Link>
                            </Nav.Item>{" "}
                            <Nav.Item>
                              <Nav.Link eventKey="Cancelled">
                                <span>{statusCount?.Cancelled}</span> {"    "}{" "}
                                Cancelled
                              </Nav.Link>
                            </Nav.Item>
                            {/* <Nav.Item
                              onClick={() => {
                                setSearchOrderSatatus(
                                  OrderStatusIds.PickupSchedued,
                                );
                                handleTabClick("waitingForPickup");
                              }}
                            >
                              <Nav.Link eventKey="Sent">
                                <span>
                                  {statusCount?.OrderUnderQualityCheck +
                                    statusCount?.PickupScheduled +
                                    statusCount?.Delivered}
                                </span>{" "}
                                Sent
                              </Nav.Link>
                            </Nav.Item> */}
                          </Nav>
                        </Col>

                        <Col sm={12}>
                          <Tab.Content>
                            <Tab.Pane eventKey="Pending">
                              <PendingOrdersTable
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                user={user}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="OrderConfirmed">
                              <OrderConfirmed
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="PickupMaterial">
                              <PickupMaterial
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="Prossesing">
                              <Prossesing
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="ReadyToDelivered">
                              <ReadyToDelivered
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="Delivered">
                              <Delivered
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="RestichingOrders">
                              <RestichingOrders
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>

                            <Tab.Pane eventKey="Cancelled">
                              <Cancelled
                                user={user}
                                activeTab={activeTab}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                GetAllCounts={() => GetAllCounts()}
                              />
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>

                  <div className=""></div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
